import Api from '@vacationtracker/shared/services/api'
import { ITeamEnergyPageResponse } from '@vacationtracker/shared/types/team-energy'
import { PTOSuggestionsResponse } from '../../EnergyLevelPage/types'

const pageCache = new Map<string, Promise<ITeamEnergyPageResponse>>()
const PAGE_CACHE_TTL_MS = 5_000

export interface IGetTeamEnergyPageOptions {
  departmentId?: string
  trendWeeks?: number
}

export const getTeamEnergyPage = (options: IGetTeamEnergyPageOptions = {}): Promise<ITeamEnergyPageResponse> => {
  const cacheKey = JSON.stringify(options)

  const existing = pageCache.get(cacheKey)
  if (existing) {
    return existing
  }

  const params = new URLSearchParams()
  if (options.departmentId) {
    params.set('departmentId', options.departmentId)
  }

  if (options.trendWeeks !== undefined) {
    params.set('trendWeeks', String(options.trendWeeks))
  }

  const qs = params.toString()
  const url = qs ? `/insights/team-energy?${qs}` : '/insights/team-energy'

  const promise = Api.get<ITeamEnergyPageResponse>(url)
  pageCache.set(cacheKey, promise)
  promise.catch(() => pageCache.delete(cacheKey))
  setTimeout(() => pageCache.delete(cacheKey), PAGE_CACHE_TTL_MS)
  return promise
}

export interface IGetMemberPtoSuggestionsOptions {
  userId: string
  fromDate: string
  toDate: string
  limit?: number
}

export const getMemberPtoSuggestions = (options: IGetMemberPtoSuggestionsOptions): Promise<PTOSuggestionsResponse> => {
  const params = new URLSearchParams({
    userId: options.userId,
    fromDate: options.fromDate,
    toDate: options.toDate,
  })
  if (options.limit !== undefined) {
    params.set('limit', String(options.limit))
  }
  return Api.get<PTOSuggestionsResponse>(`/insights/team-energy/pto-suggestions?${params.toString()}`)
}
